var _script, _path, _script2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: ""
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4179 0H15.6991V19.0724C15.6991 21.3449 13.8842 23.2116 11.6256 23.2116C9.36704 23.2116 7.55212 21.3449 7.55212 19.0724C7.55212 16.8406 9.32671 15.0145 11.5046 14.9333V10.1449C6.70515 10.2261 2.83331 14.1623 2.83331 19.0724C2.83331 24.0232 6.78581 28 11.666 28C16.546 28 20.4985 23.9826 20.4985 19.0724V9.29273C22.2732 10.5913 24.451 11.3623 26.75 11.4029V6.61449C23.2008 6.49276 20.4179 3.57101 20.4179 0Z",
    fill: "white"
  })), _script2 || (_script2 = /*#__PURE__*/React.createElement("script", {
    xmlns: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktok-icon.a98b353e07339cb5357a968200c6f249.svg";
export { ForwardRef as ReactComponent };